import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck, Zap, ArrowRight, Trophy } from 'lucide-react';
export function FinalPricingSection() {
  return <section className="py-10 md:py-12 px-4 bg-slate-900 border-t border-slate-800/50" data-id="element-52">
      <div className="max-w-2xl mx-auto text-center" data-id="element-53">
        <FadeIn data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-3" data-id="element-55">
            🔚 ÚLTIMA OPORTUNIDAD — ELEGÍ TU OPCIÓN
          </h2>
          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-slate-400 mb-6" data-id="element-56">
            <span className="flex items-center gap-1" data-id="element-57">🛡️ Garantía 30 días</span>
            <span className="hidden md:inline text-slate-700" data-id="element-58">·</span>
            <span className="flex items-center gap-1" data-id="element-59">
              ⚡ Acceso de inmediato
            </span>
            <span className="hidden md:inline text-slate-700" data-id="element-60">·</span>
            <span className="flex items-center gap-1" data-id="element-61">🔒 Pago seguro</span>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-62">
          {/* Option A - Base */}
          <FadeIn delay={0.1} data-id="element-63">
            <div className="bg-slate-950 border border-slate-800 rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-center justify-between gap-5" data-id="element-64">
              <div className="text-left flex-grow" data-id="element-65">
                <h3 className="text-xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-66">
                  <span className="text-blue-400" data-id="element-67">📘</span> SISTEMA HUMEDAD CERO
                  + 3 BONOS
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-68">
                  Para empezar con sistema · 4 Módulos + 3 Bonos
                </p>
              </div>
              <div className="text-center md:text-right flex-shrink-0" data-id="element-69">
                <div className="mb-3" data-id="element-70">
                  <span className="text-slate-500 line-through text-sm mr-2" data-id="element-71">
                    $43.940 ARS
                  </span>
                  <span className="text-2xl font-bold text-green-500" data-id="element-72">
                    $19.990 ARS
                  </span>
                </div>
                <a href="https://fegion.shop/cart/47023816179851:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 py-3 px-6 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-bold transition-colors w-full md:w-auto" data-id="element-73">
                  💧 Lo quiero
                </a>
              </div>
            </div>
          </FadeIn>

          {/* Option B - Combo */}
          <FadeIn delay={0.2} data-id="element-74">
            <div className="bg-[#1A365D] border-2 border-orange-500 rounded-2xl p-5 md:p-6 flex flex-col md:flex-row items-center justify-between gap-5 relative overflow-hidden shadow-[0_0_30px_rgba(221,107,32,0.15)]" data-id="element-75">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[10px] font-black tracking-widest uppercase px-4 py-1 rounded-b-lg" data-id="element-76">
                ⭐ El más elegido
              </div>

              <div className="text-left flex-grow mt-4 md:mt-0" data-id="element-77">
                <h3 className="text-xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-78">
                  <Trophy className="w-5 h-5 text-orange-500" data-id="element-79" /> SISTEMA HUMEDAD
                  CERO + PASAPORTE DEL MAESTRO
                </h3>
                <p className="text-orange-200 text-sm" data-id="element-80">
                  Solución completa · 4 Módulos + 3 Bonos + Kit de
                  Implementación
                </p>
              </div>
              <div className="text-center md:text-right flex-shrink-0" data-id="element-81">
                <div className="mb-3" data-id="element-82">
                  <span className="text-slate-400 line-through text-sm mr-2" data-id="element-83">
                    $74.500 ARS
                  </span>
                  <span className="text-3xl font-black text-orange-400" data-id="element-84">
                    $27.990 ARS
                  </span>
                </div>
                <a href="https://fegion.shop/cart/47023822274699:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 py-4 px-8 rounded-xl bg-green-600 hover:bg-green-500 text-white font-black transition-colors w-full md:w-auto shadow-lg" data-id="element-85">
                  → Quiero todo
                </a>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-86">
          <div className="mt-6 text-xs text-slate-500 flex flex-wrap justify-center gap-x-3 gap-y-2" data-id="element-87">
            <span data-id="element-88">🛡️ Garantía 30 días</span>
            <span data-id="element-89">·</span>
            <span data-id="element-90">⚡ Acceso de inmediato</span>
            <span data-id="element-91">·</span>
            <span data-id="element-92">🔒 Pago 100% seguro</span>
            <span data-id="element-93">·</span>
            <span data-id="element-94">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}